
import {initWebComponent} from "@/helpers/web-component-helper";
import {toggleAccordionCollapse} from "@/helpers/bootstrap-accordion-helper";
import {getBySelector, hideElementsBySelector, showElementsBySelector} from "@/helpers/element-helper";
import {clearLayerSearch} from "@/helpers/layer/menu/layer-search-helper.js";

export class LayerInfoLegendSearchComponent extends HTMLElement {
    constructor(){
        super();

        const template = document.createElement('template');
        template.innerHTML = `
<form class="form-inline mb-2 bg-lighter">
    <div class="input-group w-100">
        <span class="input-group-prepend">
          <span class="fa fa-search text-secondary"></span>
        </span>
        <input class="form-control mr-sm-2" id="iptSearchLegend" type="text" placeholder="Zoek naar legenda's" style="border-bottom: 0px">
        <span id="iptSearchLegendClear" class="fa fa-times position-absolute cursor-pointer d-none" style="right: 55px;top: 12px;z-index: 100;font-size:10px">
        </span>        
        <span class="input-group-append">
          <layer-menu-overview-collapse data-collapse="true"  data-accordion-class="layer-info-legend"></layer-menu-overview-collapse>
        </span>
        <span class="input-group-append">
          <layer-menu-overview-collapse data-collapse="false" data-accordion-class="layer-info-legend"></layer-menu-overview-collapse>  
        </span>
    </div>
</form>
</div>
`;

        initWebComponent(this, template)

        const element = this.querySelector('#iptSearchLegend')

        this.querySelector('#iptSearchLegendClear').addEventListener('click', () => {
            element.value = ''
            checkVisible()
        })

        getBySelector('#iptSearchLegend').addEventListener('keyup', (e) => {
            checkVisible()
        });

        function checkVisible() {
            toggleAccordionCollapse('layer-info-legend', false)
            const value = String(element.value).toLowerCase()

            if(value) {
                showElementsBySelector('#iptSearchLegendClear')
            } else {
                hideElementsBySelector('#iptSearchLegendClear')
            }

            document.querySelectorAll('.layer-info-legend-item').forEach( element => {
                if(value === "" || String(element.dataset.label).toLowerCase().includes(value)) {
                    element.classList.remove('d-none')
                } else {
                    element.classList.add('d-none')
                }
            })
        }
    }
}

